module.exports = __webpack_public_path__ + "static/homepage-mobile-bt-ccbedaa35b1db47783932acb0d546be1.jpg";